'use strict';
module.exports = Math.imul || function (a, b) {
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
	var ah = (a >>> 16) & 0xffff;
	var al = a & 0xffff;
	var bh = (b >>> 16) & 0xffff;
	var bl = b & 0xffff;
	return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/imul/index.js
// module id = 3
// module chunks = 0